// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html,\nbody {\n  margin: 0;\n  padding: 0;\n  border-spacing: 0;\n}\n\n.universaldatatool {\n  font-family: \"Inter\";\n}\n", ""]);
// Exports
module.exports = exports;
